module.exports = __webpack_public_path__ + "img/depmap_svg_V121.9adf57fc.svg";